import { TileRendererProvider, martinPerssonRenderer } from "../tiles/index.js"
import TopDownScreen from "../screens/play/TopDownScreen.jsx"
import FocusScreen from "../screens/play/FocusScreen.jsx"
import FocusIndScreen from "../screens/play/FocusIndScreen.jsx"
import SchematicScreen from "../screens/play/SchematicScreen.jsx"
import SchematicIndScreen from "../screens/play/SchematicIndScreen.jsx"
import EditorScreen from "../screens/edit/EditorScreen.jsx"
import ChapterPlayer from "./ChapterPlayer.jsx"

const withRenderer = (Screen) => (props) => (
  <TileRendererProvider renderer={martinPerssonRenderer}>
    <Screen {...props} />
  </TileRendererProvider>
)

const registry = {
  TopDownScreen: withRenderer(TopDownScreen),
  FocusScreen: withRenderer(FocusScreen),
  FocusIndScreen: withRenderer(FocusIndScreen),
  SchematicScreen: withRenderer(SchematicScreen),
  SchematicIndScreen: withRenderer(SchematicIndScreen),
  EditorScreen: withRenderer(EditorScreen),
  ChapterPlayer,
}

export default registry
